module.exports = __webpack_public_path__ + "img/1.3d142e69.jpg";